import { render, staticRenderFns } from "./NoResultsComponent.vue?vue&type=template&id=2ae7cab2&scoped=true&"
import script from "./NoResultsComponent.vue?vue&type=script&lang=ts&"
export * from "./NoResultsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae7cab2",
  null
  
)

export default component.exports